import { giphyDarkCharcoal } from '@giphy/colors'
import { ReactNode, useRef } from 'react'
import { PortalTooltip, useTooltip } from 'ui/src/components/controls/tooltip'
import { generateId } from 'utils'

const HoverableTooltip = ({ children, label }: { children: ReactNode; label: ReactNode }) => {
    const tooltipIdRef = useRef<string>(generateId('overlay-channel'))
    const { isOpen, listeners } = useTooltip({
        color: giphyDarkCharcoal,
        id: tooltipIdRef.current,
        triggerType: 'hover',
        width: 150,
    })
    return (
        <div {...listeners}>
            {children}
            <PortalTooltip hoverMode isOpen={isOpen}>
                <div className="p-2 text-sm">{label}</div>
            </PortalTooltip>
        </div>
    )
}

export default HoverableTooltip
